import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { currentPageState$ } from '../../redux/selectors';

const headers = [
    {
        label: <><i className="fa fa-home"></i>&nbsp;Home</>,
        to: '/',
        exact: true
    },
    {
        label: <><i className="fa fa-android" aria-hidden="true"></i>&nbsp;Ứng dụng</>,
        to: '/applications',
        exact: false
    },
    {
        label: <><i className="fa fa-scissors" aria-hidden="true"></i>&nbsp;Mã giảm giá</>,
        to: '/promotion-codes',
        exact: false
    },
    // {
    //     label: <><i className="fa fa-money"></i>&nbsp;Dịch vụ</>,
    //     to: '/services',
    //     exact: false
    // },
]

export default function NavigationBar() {
    const currentPage = useSelector(currentPageState$);

    if (currentPage !== 'public') {
        return null;
    }

    // Handle Scroll Top
    document.addEventListener('scroll', () => {
        const header = document.getElementById('header');
        const sticky = header && header.offsetTop;

        if (window.pageYOffset > sticky) {
            header && header.classList && header.classList.add('sticky');
        } else {
            header && header.classList && header.classList.remove('sticky');
        }
    });

    return (
        <div className="navigation-bar" id="header">
            <div>
                {headers && headers.map(({ label, to, exact }, index) => {
                    return (
                        <NavLink
                            key={index}
                            to={to}
                            exact={exact}
                            activeClassName="navlink-active"
                        >{label}</NavLink>
                    );
                })}
            </div>
        </div>
    )
}